// Free gift auto-add v15 - mystery gift only (tool kit removed 2026-10-08)
(function() {
  var MYSTERY = '67617957838884';
  var GIFTS = [MYSTERY];
  var mysteryOK = window.__freeGiftMysteryAvailable === true;

  function cart() { return fetch('/cart.js').then(function(r) { return r.json(); }); }
  function add(id) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function(r) { return r.json(); }).catch(function() {});
  }
  function rm(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function(r) { return r.json(); }).catch(function() {});
  }

  function updateCount(n) {
    try {
      document.querySelectorAll('.cart-bubble__text-count, [data-testid="cart-bubble"]').forEach(function(el) { el.textContent = n; });
      document.querySelectorAll('.cart-bubble').forEach(function(b) { b.style.display = n === 0 ? 'none' : ''; });
    } catch (e) {}
  }

  function addGiftsNow() {
    if (mysteryOK) addGiftAfterProduct();
    setTimeout(function() {
      cart().then(function(c) { try { updateCount(c.item_count); } catch (e) {} }).catch(function() {});
      lock();
    }, 800);
  }

  // v16: auto-add the gift only AFTER the main product add has completed,
  // so the gift add can no longer race the product add and leave only
  // the gift in the cart.
  function addGiftAfterProduct() {
    var tries = 0;
    (function waitForProduct() {
      cart().then(function(c) {
        var paid = false;
        try {
          c.items.forEach(function(i) {
            if (GIFTS.indexOf(String(i.variant_id)) === -1) paid = true;
          });
        } catch (e) {}
        if (paid) { sync(); return; } // product add completed -> sync() adds the gift if missing
        if (tries < 12) { tries++; setTimeout(waitForProduct, 500); return; }
        sync(); // final attempt; sync() safely no-ops if there is nothing to do
      }).catch(function() {});
    })();
  }

  var busy = false;
  function sync() {
    if (busy) return;
    busy = true;
    cart().then(function(c) {
      var has = {}, gk = [], paid = false;
      try {
        c.items.forEach(function(i) {
          var v = String(i.variant_id);
          has[v] = true;
          if (GIFTS.indexOf(v) !== -1) gk.push(i.key);
          else paid = true;
        });
      } catch (e) { busy = false; return; }
      var ops = [];
      if (!paid && gk.length) gk.forEach(function(k) { ops.push(function() { return rm(k); }); });
      if (paid && mysteryOK && !has[MYSTERY]) ops.push(function() { return add(MYSTERY); });
      if (!ops.length) { busy = false; return; }
      var p = Promise.resolve();
      ops.forEach(function(fn) { p = p.then(fn); });
      p.then(function() {
        busy = false;
        cart().then(function(nc) { try { updateCount(nc.item_count); } catch (e) {} }).catch(function() {});
        setTimeout(lock, 400);
      }).catch(function() { busy = false; });
    }).catch(function() { busy = false; });
  }

  function cls(el, sel) {
    try {
      if (!el || el.nodeType !== 1) el = el && el.parentElement ? el.parentElement : null;
      return el && el.closest ? el.closest(sel) : null;
    } catch (e) { return null; }
  }

  var ADD_SEL = 'button[name="add"], input[name="add"], .add-to-cart, [data-add-to-cart], form[action="/cart/add"] button[type="submit"], [name="add"], .product-form__submit, .quick-add__submit';
  var RM_SEL = 'a[href*="/cart/change"], button[name="remove"], [data-cart-remove], .cart__remove, .cart-item__remove, button[aria-label*="Remove"], .cart-remove, [href*="cart/change"]';

  document.addEventListener('click', function(e) {
    try {
      if (cls(e.target, ADD_SEL)) { addGiftsNow(); return; }
      if (cls(e.target, RM_SEL)) { setTimeout(sync, 600); setTimeout(sync, 1600); }
    } catch (err) {}
  }, true);

  document.addEventListener('click', function(e) {
    try {
      var drawerTrigger = cls(e.target, '[data-drawer-open], .cart-drawer-toggle, a[href="/cart"], .header__cart');
      if (drawerTrigger) setTimeout(sync, 300);
    } catch (err) {}
  });

  function lock() {
    try {
      GIFTS.forEach(function(vid) {
        document.querySelectorAll('[data-variant-id="' + vid + '"]').forEach(function(item) {
          item.querySelectorAll('a[href*="/cart/change"], button[name="remove"], [data-cart-remove], .cart__remove, .cart-item__remove, button[aria-label*="Remove"]').forEach(function(b) { try { b.style.display = 'none'; } catch (e) {} });
          item.querySelectorAll('input[type="number"], input[name="updates[]"]').forEach(function(i) { try { i.setAttribute('disabled', 'disabled'); i.value = '1'; } catch (e) {} });
          item.querySelectorAll('.quantity__button, [data-quantity-plus], [data-quantity-minus]').forEach(function(b) { try { b.style.display = 'none'; } catch (e) {} });
          if (!item.querySelector('.free-gift-badge')) {
            var s = document.createElement('span');
            s.className = 'free-gift-badge'; s.textContent = 'FREE GIFT';
            s.setAttribute('style', 'display:inline-block;background:#7c3aed;color:#fff;font-size:10px;font-weight:700;padding:2px 8px;border-radius:10px;margin-left:8px;');
            var t = item.querySelector('.cart-item__name, a[href*="/products/"]');
            if (t) t.appendChild(s); else item.appendChild(s);
          }
        });
      });
    } catch (e) {}
  }

  var mo = null;
  try { mo = new MutationObserver(function() { lock(); }); } catch (e) {}

  function init() {
    try {
      sync();
      if (mo) mo.observe(document.body, { childList: true, subtree: true });
      lock();
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
